import { resolveComponent as _resolveComponent, createVNode as _createVNode, createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, createStaticVNode as _createStaticVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { class: "row w-100" }
const _hoisted_2 = { class: "card-body w-50" }
const _hoisted_3 = { class: "card-body w-50" }
const _hoisted_4 = { class: "pb-10 pb-lg-15" }
const _hoisted_5 = /*#__PURE__*/_createStaticVNode("<h2 class=\"fw-bolder d-flex align-items-center text-dark mb-6\"> Inclusion Criteria <i class=\"fas fa-exclamation-circle ms-2 fs-7\" data-bs-toggle=\"tooltip\" title=\"Inclusion Criteria\"></i></h2><div class=\"fv-row mb-10 mb-6\"><label class=\"fs-6 fw-bold mb-6\"> 1. What are the Inclusion and Exclusion criteria for subjects in this study? </label></div><label class=\"d-flex align-items-center form-label\"><span class=\"required\"> Inclusion Criteria:</span></label>", 3)
const _hoisted_8 = { class: "fv-row mb-10" }
const _hoisted_9 = /*#__PURE__*/_createElementVNode("label", { class: "d-flex align-items-center form-label" }, [
  /*#__PURE__*/_createElementVNode("span", { class: "required" }, " Exclusion Criteria:")
], -1)

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_DropDownSection = _resolveComponent("DropDownSection")!
  const _component_IrbGptSection = _resolveComponent("IrbGptSection")!
  const _component_editor = _resolveComponent("editor")!
  const _component_Field = _resolveComponent("Field")!
  const _component_ErrorMessage = _resolveComponent("ErrorMessage")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _createVNode(_component_DropDownSection, {
        title: "Review for more information",
        list: _ctx.listDropDownSections
      }, null, 8, ["list"]),
      _createVNode(_component_IrbGptSection)
    ]),
    _createElementVNode("div", _hoisted_3, [
      _createElementVNode("div", _hoisted_4, [
        _hoisted_5,
        _createVNode(_component_editor, {
          for: "measureDetail",
          initialValue: "step3.q3_1",
          modelValue: _ctx.step3.q3_1,
          "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((_ctx.step3.q3_1) = $event)),
          "api-key": _ctx.currentEditorToken,
          licenseKey: "gpl",
          init: {
            height: 200,
            menubar: false,
            plugins: [
              'advlist autolink lists link image charmap',
              'searchreplace visualblocks code fullscreen',
              'print preview anchor insertdatetime media',
              'paste code help wordcount table',
            ],
            toolbar:
              'undo redo | formatselect | bold italic |         alignleft aligncenter alignright |         bullist numlist outdent indent | help',
          }
        }, null, 8, ["modelValue", "api-key"]),
        _createVNode(_component_Field, {
          type: "hidden",
          name: "q3_1",
          initialValue: "",
          for: "Inclusion Criteria",
          class: "form-control form-control-lg form-control-solid mb-3 mb-lg-0",
          placeholder: "Inclusion Criteria",
          modelValue: _ctx.step3.q3_1,
          "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((_ctx.step3.q3_1) = $event))
        }, null, 8, ["modelValue"]),
        _createVNode(_component_ErrorMessage, {
          name: "q3_1",
          class: "fv-plugins-message-container invalid-feedback"
        })
      ]),
      _createElementVNode("div", _hoisted_8, [
        _hoisted_9,
        _createVNode(_component_editor, {
          for: "measureDetail",
          initialValue: "step3.q3_2",
          modelValue: _ctx.step3.q3_2,
          "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => ((_ctx.step3.q3_2) = $event)),
          "api-key": _ctx.currentEditorToken,
          licenseKey: "gpl",
          init: {
            height: 200,
            menubar: false,
            plugins: [
              'advlist autolink lists link image charmap',
              'searchreplace visualblocks code fullscreen',
              'print preview anchor insertdatetime media',
              'paste code help wordcount table',
            ],
            toolbar:
              'undo redo | formatselect | bold italic |         alignleft aligncenter alignright |         bullist numlist outdent indent | help',
          }
        }, null, 8, ["modelValue", "api-key"]),
        _createVNode(_component_Field, {
          type: "hidden",
          name: "q3_2",
          initialValue: "",
          for: "Exclusion Criteria",
          class: "form-control form-control-lg form-control-solid mb-3 mb-lg-0",
          placeholder: "Exclusion Criteria",
          modelValue: _ctx.step3.q3_2,
          "onUpdate:modelValue": _cache[3] || (_cache[3] = ($event: any) => ((_ctx.step3.q3_2) = $event))
        }, null, 8, ["modelValue"]),
        _createVNode(_component_ErrorMessage, {
          name: "q3_2",
          class: "fv-plugins-message-container invalid-feedback"
        })
      ])
    ])
  ]))
}